<template>
    <div :class="{ 'w33' : cols === 3, 'w50' : cols === 2 }" v-if="task">
        <Drop
            @drop="moveLocationItem"
        >
            <Drag
                :transferData="{
                    type: 'task',
                    fromTaskIndex: taskIndex,
                    location: location
                  }"
                @click.native="goToTask(task)"
            >
                <div class="cards-edit-box"
                     :id="'task-badge-' + task.id"
                     :style="{ backgroundColor: convertHex(task.colour_label, 40) }"
                >
                    <div class="edit-cards-start board-cart-title text-word-break">
                        <span>{{ task.name }}</span>
                    </div>
                </div>
            </Drag>
        </Drop>
        <!-- popup -->

    </div>

</template>

<script>
import MovingDataPlannerItems from "../../mixins/MovingDataPlannerItems";
import Drag from "./Drag";
import Drop from "./Drop";
import {VueFinalModal} from 'vue-final-modal/lib'

export default {
    name: "ColTask",
    props: {
        location: {
          type: String,
          required: true
        },
        task: {
            type: Object,
            required: true
        },
        taskIndex: {
            type: Number,
            required: true
        },
        cols: {
          type: Number,
          required: true
        },

    },
    data: () => {
        return {
            showModal: false,
            colour_label: null,
        };
    },
    components: { Drag, Drop, VueFinalModal },
    mixins: [MovingDataPlannerItems],
    methods: {
        goToTask (task) {
            let params = { id: task.id };
            if(this.$route.params.doc_id) {
                params.doc_id = this.$route.params.doc_id;
            } else {
                let url = window.location.href;
                let urlArray = url.split('/');
                // saved in the database
                if(urlArray.length > 5 && urlArray[5] != 'task' && urlArray[5]) {
                    params.doc_id = urlArray[5];
                }
            }
            this.$router.push({ name: 'Model Planner Task', params: params })
        },
        convertHex(hexCode,opacity){
            if(! hexCode) {
                return null;
            }
            let hex = hexCode.replace('#','');

            if (hex.length === 3) {
                hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
            }

            let r = parseInt(hex.substring(0,2), 16),
                g = parseInt(hex.substring(2,4), 16),
                b = parseInt(hex.substring(4,6), 16);

            return 'rgba('+r+','+g+','+b+','+opacity/100+')';
        },

    }
}
</script>

<style scoped>
.dev-priorities-ideas .cards-edit-box {
  width: 100%;
}


.w33 {
  width: calc(33% - 10px);
}

.w50 {
  width: calc(50% - 10px);
}

</style>
